import type { JSX } from "react"
import BoltRoundedIcon from "@mui/icons-material/BoltRounded"
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded"

import type { EntityType } from "types/common.types"
import TowerIcon from "icons/TowerIcon"
import DeviceIcon from "icons/DeviceIcon"
import SpanIcon from "icons/SpanIcon"

export interface EntityVisual {
  // Renders the entity glyph at the given size, tinted with `color`. Owning the
  // render here hides the per-icon API differences behind one uniform call.
  renderIcon: (args: { color: string; size: number }) => JSX.Element
  // Theme palette paths — resolved via useTheme in EntityIcon, or passed
  // straight to MUI sx (bgcolor/borderColor resolve theme paths themselves).
  colorPath: string
  lightPath: string
}

// Single source of truth for "which icon + which color" per entity. Non-entity
// sources (e.g. the third-party weather service) render their own dedicated
// icons and are intentionally not covered here.
export const ENTITY_VISUALS: Record<EntityType, EntityVisual> = {
  tower: {
    renderIcon: ({ color, size }) => (
      <TowerIcon color={color} width={size} height={size} />
    ),
    colorPath: "extras.limeGreen.main",
    lightPath: "extras.limeGreen.light",
  },
  device: {
    renderIcon: ({ color, size }) => (
      <DeviceIcon color={color} width={size} height={size} />
    ),
    colorPath: "extras.purple.main",
    lightPath: "extras.purple.light",
  },
  powerline: {
    renderIcon: ({ color, size }) => <BoltRoundedIcon sx={{ color, fontSize: size }} />,
    colorPath: "extras.blue.main",
    lightPath: "extras.blue.light",
  },
  group: {
    renderIcon: ({ color, size }) => (
      <GridViewRoundedIcon sx={{ color, fontSize: size }} />
    ),
    colorPath: "extras.orange.main",
    lightPath: "extras.orange.light",
  },
  span: {
    renderIcon: ({ color, size }) => (
      <SpanIcon color={color} width={size} height={size} />
    ),
    colorPath: "extras.softIndigo.main",
    lightPath: "extras.softIndigo.light",
  },
}
